<template>
 <div class="main">
  <div class="zhaomuBox">
    <div class="formWrap">
      <!-- <form class="formCooperation">
        <h3>招募</h3>
        <p>门店·县级代理·合伙人</p>
        <div class="inputWrap">
        <input v-validate="'required|name'" :class="{'is-danger': errors.has('email') }" v-model="name" class="name" type="text" name="name" placeholder="您的姓名">
        <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
        </div>
        <div class="inputWrap">
        <input v-validate="'required|mobile'" :class="{'is-danger': errors.has('phone') }" v-model="phone" class="telephone" type="text" name="phone" placeholder="您的手机号码">
        <span v-show="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</span>
        </div>
        <div class="inputWrap">
        <select class="type" type="text" v-model="type" v-validate="'required|type'" :class="{'is-danger': errors.has('type') }" name="type">
          <option value="">请选择</option>
          <option value="招募门店">招募门店</option>
          <option value="县级代理">县级代理</option>
          <option value="合伙人">合伙人</option>
        </select>
        <span v-show="errors.has('type')" class="help is-danger">{{ errors.first('type') }}</span>
        </div>
        <div class='submitBtn' v-on:click="submitInfos">提交资料</div>
      </form> -->
    </div>
    <slider animation="fade" :interval="3000">
      <slider-item><img src="@/assets/images/banner1.jpg" height="100%"></slider-item>
      <slider-item><img src="@/assets/images/banner2.jpg" height="100%"></slider-item>
    </slider>
  </div>
  <div class="module cooperation" >
      <div class="title">羊村董妈咪合作权益</div>
      <div class="contentWidth clearfix">
        <router-link to="aboutUs#gongyinglian" class="item fleft">
          <img class="itemImg" src="../assets/images/gongyinglian.png" alt="">
          <h3 class="labelTitle">母婴B2B供应链平台</h3>
          <div class="itemLabel">
            <div>一站式订货平台价格更优,多品牌产品矩阵</div>
            <div>两级进销存管理</div>
            <div>下辖门店运营支持</div>
            <router-link to="aboutUs#gongyinglian" class="more">了解更多</router-link>
          </div>
        </router-link>
        <router-link to="aboutUs#zhinengyunying" class="item fleft">
          <img class="itemImg" src="../assets/images/zhinengyunying.png" alt="">
          <h3 class="labelTitle">母婴门店智能运营平台</h3>
          <div class="itemLabel">
            <div>平台一键订货,优选品牌产品</div>
            <div>门店运营支持</div>
            <div>数据智能运营管理</div>
            <router-link to="aboutUs#zhinengyunying" class="more">了解更多</router-link>
          </div>
        </router-link>
        <router-link to="aboutUs#service" class="item fleft">
          <img class="itemImg" src="../assets/images/fuwupingtai.png" alt="">
          <h3 class="labelTitle">消费者母婴服务平台</h3>
          <div class="itemLabel">
            <div>会员服务</div>
            <div>母婴知识服务</div>
            <div>妈妈圈</div>
            <router-link to="aboutUs#service" class="more">了解更多</router-link>
          </div>
        </router-link>
      </div>
  </div>
  <div class="module introduce">
      <div class="title">羊村集团概况</div>
      <div class="contentWidth">
        <div class="item clearfix">
          <div class="detail fleft">
              <h1>荣誉见证</h1>
              <p>消费者产权模式开创者<br>打造了羊村董妈咪母婴数据智能平台<br>荣获2017年“年度最佳新零售创新大奖” </p>
          </div>
          <img class="fright" src="@/assets/images/honor.png" width="416" height="296" />
        </div>
        <div class="item clearfix">
          <div class="team fleft">
            <h1>资深数据研发团队</h1>
            <p>IT工程师&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大数据工程师<br>机器学习专家&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;资深产品经理 </p>
          </div>
          <div class="market fright">
            <h1>市场覆盖</h1>
            <p>年销售过亿<br>覆盖全国30余省市区<br>链接门店数10000余家</p>
          </div>
        </div>
      </div>
  </div>
  <div class="module">
      <div class="title">战略合作品牌</div>
      <div class="contentWidth brand">
        <a href="#">
           <img src="@/assets/images/logoduomeizi.png" width="257" height="115" />
        </a>
        <a href="#">
           <img src="@/assets/images/logoyashili.png" width="257" height="115" />
        </a>
        <a href="#">
           <img src="@/assets/images/logomengniu.png" width="257" height="115" />
        </a>
        <a href="#">
           <img src="@/assets/images/logoyubaoyangnai.png" width="257" height="115" />
        </a>
      </div>
  </div>
 </div>
</template>

<script>
// import $ from 'jquery'
import { Slider, SliderItem } from 'vue-easy-slider'

import api from '../config/api'

import Vue from 'vue'
import VeeValidate, {Validator} from 'vee-validate'
import cn from 'vee-validate/dist/locale/zh_CN'

Validator.localize('cn', cn)

const dictionary = {
  cn: {
    messages: {
      required: (field) => '请输入' + field
    },
    attributes: {
      type: '合作类型',
      name: '姓名',
      phone: '手机号码'
    }
  }
}

Validator.localize(dictionary)

const config = {
  events: 'blur'
}

Vue.use(VeeValidate, config)

export default {
  name: 'home',
  data () {
    return {
      name: '',
      phone: '',
      type: '',
      submitStatus: false
    }
  },
  components: {
    Slider,
    SliderItem
  },
  created () {
    Validator.extend('name', {
      getMessage: field => '请输入正确的姓名',
      validate: value => /^[\u4E00-\u9FA5]{1,5}$/.test(value)
    })
    Validator.extend('mobile', {
      getMessage: field => '请输入正确的手机号码',
      validate: value => value.length === 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/.test(value)
    })
    Validator.extend('type', {
      getMessage: field => '请选择合作类型',
      validate: value => value !== ''
    })
  },
  methods: {
    submitInfos () {
      if (this.submitStatus === true) {
        return
      }
      this.$validator.validateAll().then((result) => {
        if (result === true) {
          this.submitStatus = true
          var params = {
            'name': this.name,
            'telephone': this.phone,
            'type': this.type
          }
          api.addRecruiter(params)
            .then(res => {
              this.submitStatus = false
              if (res.code === 0) {
                this.name = ''
                this.phone = ''
                this.type = ''
                this.$emit('tipsShow', '提交成功！')
              } else {
                this.$emit('tipsShow', '提交失败，请重新填写一遍吧~')
              }
            })
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
.main{
  .zhaomuBox{
    position: relative;
    z-index: 0;
    width: 100% !important;
    height: 700px !important;
    .slider {
      width: 100% !important;
      height: 700px !important;
      min-width: 1100px;
    }
    .formWrap{
      position: absolute;
      z-index: 100;
      width:1100px;
      height: 100%;
      left: 50%;
      margin-left:-550px;
      top:0;
    }
    .formCooperation{
      z-index: 100;
      position: absolute;
      top: 50%;
      margin-top:-182px;
      right: 0;
      width: 298px;
      height: 310px;
      background: #fff;
      padding: 26px;
      border: 1px solid #c9c9c9;
      text-align: center;
      border-radius: 4px;
      color: #333;
      h3{
          font-size: 26px;
          height: 40px;
          line-height: 40px;
        }
      p{
          font-size: 22px;
          height: 36px;
          line-height: 36px;
          margin-bottom: 12px;
      }
      input, select{
        font-family: "microsoft yahei";
        width:268px;
        height: 36px;
        border: 1px solid #ddd;
        border-radius: 4px;
        margin-bottom: 17px;
        padding: 0 12px;
        color: #999;
        outline: none;
        font-size: 16px;
      }
      ::-webkit-input-placeholder { /* WebKit browsers */
         color: #999;
      }
      :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
       color: #999;
      }
      ::-moz-placeholder { /* Mozilla Firefox 19+ */
       color: #999;
      }
      :-ms-input-placeholder { /* Internet Explorer 10+ */
       color: #999;
      }
      select{
        width: 298px;
        appearance:none;
        -moz-appearance:none;
        -webkit-appearance:none;
        padding-right: 14px;
        background:#fff url(../assets/images/ic_xiala.png) no-repeat scroll 277px center;
        background-size: 8px;
      }
      select::-ms-expand { display: none; }
      .submitBtn{
        cursor: pointer;
        width: 298px;
        height: 50px;
        line-height: 50px;
        background: #f95374;
        color: #fff;
        border-radius: 4px;
        margin-top: 7px;
        font-size: 16px;
      }
      .inputWrap{
          position: relative;
          span{position: absolute;font-size: 12px;color: #f95374;left: 2px;top: 38px;}
      }
     }
    }
  .module{
    padding-top: 92px;
    .title{
      text-align: center;
      font-size: 26px;
      color:#333;
      margin-bottom: 52px;
      background: url(../assets/images/line.png) bottom center no-repeat;
      padding-bottom: 22px;
    }
   &.introduce{
    .item{
      margin-top: 12px;
      color: #fff;
      text-align: center;
      &:first-child{margin-top:0;};
      .detail{
        width:672px;
        height: 296px;
        background-color: #f95374;
      }
      h1{font-size:30px;font-weight: bold;color: #fff;line-height: 30px; margin: 56px 0 40px 0;}
      p{
        font-size: 24px;
        line-height: 40px;
      }
      .team,.market{
        background-color: #6eb9ff;
        width: 544px;
        height: 296px;
      }
      .team h1{margin: 56px 0 58px 0;}
    }
  }
    &.cooperation{
        .item{
          width: 348px;
          height: 440px;
          text-align: center;
          color: #f6f6f6;
          background-color: #3b4351;
          border-radius: 4px;
          margin-left:26px;
          &:first-child{margin:0;}
          .itemImg{
            margin: 56px auto 32px;
          }
          .labelTitle{
            font-size: 22px;
            line-height: 22px;
            font-weight: bold;
          }
          .itemLabel{
            margin-top: 24px;
            font-size: 16px;
            line-height: 24px;
            color: #f6f6f6;
          }
          .more{
            margin: 25px auto;
            display: block;
            font-size: 14px;
            color: #f6f6f6;
            width: 124px;
            height: 32px;
            line-height: 32px;
            background-color: #6c778a;
            border-radius: 28px;
          }
      }
    }
  }
  .brand{
    display: flex;
    justify-content: space-between;
    margin-bottom: 90px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main.vue